import { createAxiosClient } from "@ntg/component-library/utilities";
import { useMutation } from "@tanstack/react-query";

const apiClient = createAxiosClient("D365FO");

interface IManufacturingSyncPayload {
    designID: number;
    mItemID: number;
}

async function manufacturingSync(
    payload: IManufacturingSyncPayload,
): Promise<string> {
    const response = await apiClient.post<string>(
        "/FunctionAppsStarter/ManufacturingSync",
        payload,
    );
    return response.data;
}

export function useManufacturingSync() {
    return useMutation({
        mutationFn: manufacturingSync,
    });
}
